import { Component, input, viewChild } from '@angular/core';
import { RidAudioButton } from '../rid-audio-button/rid-audio-button';

@Component({
  selector: 'rid-audio-card',
  imports: [RidAudioButton],
  templateUrl: './rid-audio-card.html',
})
export class RidAudioCard {
  src = input.required<string | { pronounce: string }>();
  appearance = input<'DEFAULT' | 'INCORRECT' | 'CORRECT'>('DEFAULT');

  audioButton = viewChild.required<RidAudioButton>('audioButton');

  async play() {
    await this.audioButton().play();
  }
}
